import React from 'react';
import BubbleOrb from './BubbleOrb';
import BubbleAura from './BubbleAura';
import { bubbleImageSrc } from '@/lib/bubbleImage';

// Card showing a bubble's image (from Gemini) with fallback to 3D orb.
const BubbleCard = ({ bubble, size = 'md', showLabel = true, onClick }) => {
  const { rarity = 'common', name, trait, mood } = bubble || {};
  const imgSrc = bubbleImageSrc(bubble);
  const sizes = {
    sm: 'h-32 w-32',
    md: 'h-56 w-56',
    lg: 'h-72 w-72',
    xl: 'h-[24rem] w-[24rem]',
  };

  return (
    <button
      onClick={onClick}
      data-testid={`bubble-card-${bubble?.id || 'x'}`}
      className="group flex flex-col items-center gap-3 focus:outline-none"
    >
      <div className={`relative ${sizes[size]} rounded-full overflow-hidden`}>
        <div
          className={`absolute inset-0 rounded-full blur-2xl opacity-50 pointer-events-none bg-rar-${rarity}`}
        />
        <BubbleAura bubble={bubble} className="h-full w-full">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={name}
            className="relative z-10 h-full w-full object-cover rounded-full breathe group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="relative z-10 h-full w-full">
            <BubbleOrb rarity={rarity} size={size === 'xl' ? 'xl' : size === 'lg' ? 'lg' : 'md'} />
          </div>
        )}
        </BubbleAura>
        <div className="absolute inset-0 rounded-full ring-1 ring-white/15 pointer-events-none" />
      </div>
      {showLabel && (
        <div className="text-center">
          <div className="font-display font-bold text-base leading-tight">{name || 'Bubble'}</div>
          <div className="mt-1 flex items-center justify-center gap-2 text-[10px] uppercase tracking-widest">
            <span className={`rar-${rarity} font-bold`}>{rarity}</span>
            <span className="text-white/55">•</span>
            <span className="text-white/60">{trait}</span>
            {mood && (<><span className="text-white/55">•</span><span className="text-bx-volt">{mood}</span></>)}
          </div>
        </div>
      )}
    </button>
  );
};

export default BubbleCard;
